// src/components/Footer.js
import React from 'react';
import './Footer.css'; // Styles specific to Footer

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Left Section */}
        <div className="footer-left">
          <span className="version">v236</span>
          <span className="language-selector">English</span>
        </div>
        {/* Middle Section */}
        <div className="footer-middle">
          <a href="/rules">Rules</a>
          <a href="/about">About</a>
          <a href="/careers">Careers</a>
          <a href="/community">Community</a>
          <a href="/blog">Blog</a>
          <a href="/faq">FAQ</a>
          <a href="/privacy">Privacy</a>
          <a href="/terms-and-conditions.pdf" target="_blank" rel="noopener noreferrer">Terms & Conditions</a>
          <a href="/playing-rules.pdf" target="_blank" rel="noopener noreferrer">Playing Rules</a>
        </div>
        {/* Right Section */}
        <div className="footer-right">
          <a href="https://discord.gg/9eRCXz39" target="_blank" rel="noopener noreferrer" className="social-icon">
            <img src="/assets/discord-icon.svg" alt="Discord" />
          </a>
          {/* Add more social icons as needed */}
        </div>
      </div>
      {/* Removed the copyright */}
    </footer>
  );
};

export default Footer;
